"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _keys = _interopRequireDefault(require("lodash/fp/keys"));
var _isNumber = _interopRequireDefault(require("lodash/fp/isNumber"));
var _connectGrid = _interopRequireDefault(require("../Grid/connectGrid"));
var _excluded = ["children", "className", "rowGap", "colGap", "style"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  span: 12
};
var RESPONSIVE_CLASS_MAPPING = {
  span: 'span',
  spanSm: 'span-sm',
  spanMd: 'span-md',
  spanLg: 'span-lg',
  spanXl: 'span-xl',
  spanXxl: 'span-xxl',
  order: 'order',
  orderSm: 'order-sm',
  orderMd: 'order-md',
  orderLg: 'order-lg',
  orderXl: 'order-xl',
  orderXxl: 'order-xxl',
  offset: 'offset',
  offsetSm: 'offset-sm',
  offsetMd: 'offset-md',
  offsetLg: 'offset-lg',
  offsetXl: 'offset-xl',
  offsetXxl: 'offset-xxl'
};
var GridItem = function GridItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    rowGap = _ref.rowGap,
    colGap = _ref.colGap,
    style = _ref.style,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var responsiveClassNames = (0, _keys["default"])(rest).reduce(function (pre, curKey) {
    if (RESPONSIVE_CLASS_MAPPING[curKey]) {
      return pre.concat("".concat(RESPONSIVE_CLASS_MAPPING[curKey], "-").concat(rest[curKey]));
    }
    return pre;
  }, []);
  var calculatedStyle = React.useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, (0, _isNumber["default"])(colGap) && colGap >= 0 && {
      paddingLeft: colGap / 2,
      paddingRight: colGap / 2
    }), (0, _isNumber["default"])(rowGap) && rowGap >= 0 && {
      paddingTop: rowGap / 2,
      paddingBottom: rowGap / 2
    }), style || {});
  }, [style, colGap, rowGap]);
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])('grid-item', responsiveClassNames, className),
    style: calculatedStyle
  }, children);
};
GridItem.defaultProps = defaultProps;
var GridItemContainer = (0, _connectGrid["default"])(GridItem);
var _default = exports["default"] = GridItemContainer;